import React from "react";
import { ArrowLeft } from "../AdminIcons";
import FormSelect from "../common/FormSelect";

const planOptions = [
  { label: "Filter by Plan", value: "" },
  { label: "Basic", value: "Basic" },
  { label: "Standard", value: "Standard" },
  { label: "Premium", value: "Premium" },
];

const defaultCourseOptions = [
  { label: "Filter by course", value: "" },
];

const TopFilter = ({
  selectedPlan,
  selectedCourse,
  onPlanChange,
  onCourseChange,
  courseOptions = defaultCourseOptions,
}) => {
  return (
    <section className="rounded-xl max-w-[1448px] bg-white px-4 sm:px-8 pb-4 sm:pb-8 pt-4">
      <button type="button" aria-label="Go back" className="text-[#4A4A68]">
        <ArrowLeft />
      </button>

      <h2 className="mt-2 text-xl sm:text-2xl  font-bold   text-[#111827] leading-[23px]">
        Enrolled Students
      </h2>

      <div className="mt-5 flex  items-center gap-3 sm:gap-8 md:gap-12">
        <div className="flex items-center   gap-4">
          <span className="text-base  text-black hidden sm:block">Plan</span>
          <FormSelect
            id="student-progress-plan"
            options={planOptions}
            defaultValue={selectedPlan}
            placeholder="Filter by Plan"
            onChange={onPlanChange}
            className="w-[140px]"
            selectClassName="rounded-lg border border-[#938A96] px-3 sm:px-4 py-2 sm:py-2.5 text-sm  text-black"
            dropdownClassName="left-0 right-auto mt-1 min-w-[140px] rounded-lg border border-[#E5E7EB] bg-white py-1 shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
            optionClassName="px-3 py-1 text-sm text-[#374151] hover:bg-[#F3F4F6]"
          />
        </div>

        <div className="flex items-center gap-4">
          <span className="text-base text-black hidden sm:block">Course</span>
          <FormSelect
            id="student-progress-course"
            options={courseOptions}
            defaultValue={selectedCourse}
            placeholder="Filter by course"
            onChange={onCourseChange}
            className="w-[140px]"
            selectClassName="rounded-lg border border-[#938A96] px-3 sm:px-4 py-2 sm:py-2.5 text-sm  text-black"
            dropdownClassName="left-0 right-auto mt-1 min-w-[140px] rounded-md border border-[#E5E7EB] bg-white py-1 shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
            optionClassName="px-3 py-1 text-sm text-[#374151] hover:bg-[#F3F4F6]"
          />
        </div>
      </div>
    </section>
  );
};

export default TopFilter;
